'use strict';

const styles = theme => ({
    searchInput: {
		paddingLeft: '15px',
		fontSize: theme.typography.fontSize,
	},
    block: {
		display: 'block',
	},
    searchButton: {
		marginRight: theme.spacing.unit,
	},
    searchBar: {
		borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
	},
	progressbar: {
		width: '100%',
		height: '50%',
		textAlign: 'center'
	},
	contentWrapper: {
		margin: '40px 16px',
	},
	chip: {
		margin: theme.spacing(0.5),
	},
});

export default styles;